import { render, staticRenderFns } from "./CellRendererBrTransfererActions.vue?vue&type=template&id=4e81ffe4&"
import script from "./CellRendererBrTransfererActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererBrTransfererActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports